<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'report.Annual Report' | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item active">
                        <a class="nav-link" href="/publication/published-report">{{ 'report.Annual Report' | translate }}</a>
                    </li>      
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-financial">{{ 'report.Key Financial Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-operational">{{ 'report.Key Operational Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/csr">{{ 'report.CSR' | translate }}</a>
                    </li>             
                </ul>
            </div>
        </nav>
        <div class="report-list">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/annual_report_2024.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2024' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2024_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2024_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_2.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2023' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2023_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2023_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_3.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2022' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2022_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2022_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_4.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2021' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2021_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2021_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_5.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2020' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2020_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2020_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_6.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2019' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2019_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2019_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_7.jpg'" alt="">
                        </div>
                        <div class="col-6">
                            <h2>{{ 'published_report.Annual' | translate }}</h2>
                            <p>{{ 'published_report.Report 2018' | translate }}</p>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2018_English.pdf'" target="_blank">
                                <button class="btn btn-primary">{{ 'published_report.ENG' | translate }}</button>
                            </a>
                            <a [href]="baseApiUrl + '/uploads/pdf_files/Annual-Report-2018_Khmer.pdf'" target="_blank">
                                <span style="margin-left: 10px;"><button class="btn btn-primary">{{ 'published_report.KH' | translate }}</button></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
